function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React, { useState } from 'react';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { BLUE, Box, Divider, GRAY, InputAdornment, RED, TextField, makeStyles } from '@applyboard/ui-components';
import { NO_RESULTS_FOUND } from "../Constants";
import { SearchIcon } from "../../../../assets/images";
import ErrorMessage from "../ErrorMessage";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
var useStyles = makeStyles({
  divider: {
    '&.MuiDivider-root': {
      margin: '4px 0'
    }
  },
  groupUl: {
    padding: 0,
    '& $option': {
      paddingLeft: 24
    }
  },
  inputRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: function borderColor(p) {
        return p.isError ? RED[9] : GRAY[15];
      }
    }
  },
  leftAdornment: {
    marginLeft: '8px'
  },
  option: {
    '&.MuiAutocomplete-option[data-focus="true"]': {
      backgroundColor: BLUE[19]
    }
  },
  searchContainer: {
    width: '100%',
    padding: 0
  },
  listbox: {
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Open Sans',
    color: GRAY[5]
  },
  icon: {
    color: GRAY[5]
  }
});
var filterOptions = createFilterOptions({
  ignoreAccents: true,
  ignoreCase: true,
  matchFrom: 'start',
  stringify: function stringify(option) {
    return option.name;
  }
});
var GROUPS = {
  PINNED: 'pinned',
  UNPINNED: 'unpinned'
};
export function SearchComponentV2(_ref) {
  var keyName = _ref.keyName,
    pinnedItems = _ref.pinnedItems,
    items = _ref.items,
    placeholder = _ref.placeholder,
    field = _ref.field,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? null : _ref$onSelect,
    clearError = _ref.clearError,
    _ref$isOutlined = _ref.isOutlined,
    isOutlined = _ref$isOutlined === void 0 ? false : _ref$isOutlined,
    errorMessage = _ref.errorMessage,
    setField = _ref.setField;
  var isError = Boolean(errorMessage);
  var styles = useStyles({
    isError: isError
  });
  var searchComponentId = "".concat(keyName, "-search-component");
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var pinnedItemSet = new Set(pinnedItems);
  return /*#__PURE__*/React.createElement(Box, {
    className: styles.searchContainer
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    classes: {
      listbox: styles.listbox,
      groupUl: styles.groupUl,
      inputRoot: styles.inputRoot,
      option: styles.option
    },
    filterOptions: filterOptions,
    id: searchComponentId,
    options: items.sort(function (a, b) {
      var isAPinned = pinnedItemSet.has(a.name);
      var isBPinned = pinnedItemSet.has(b.name);
      if (isAPinned && isBPinned) {
        return pinnedItems.indexOf(a.name) < pinnedItems.indexOf(b.name) ? -1 : 1;
      }
      if (inputValue || !isAPinned && !isBPinned) {
        return -b.name.localeCompare(a.name);
      }
      if (isAPinned) {
        return -1;
      }
      return 1;
    }),
    groupBy: inputValue ? null : function (option) {
      return pinnedItemSet.has(option.name) ? GROUPS.PINNED : GROUPS.UNPINNED;
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return option.name === value.name;
    },
    inputValue: inputValue,
    noOptionsText: NO_RESULTS_FOUND,
    onChange: function onChange(event, newValue, reason) {
      var entry = {};
      if (reason === 'clear') {
        entry.code = '';
        entry.name = '';
      } else {
        entry.code = newValue.code;
        entry.name = newValue.name;
      }
      setField({
        key: keyName,
        value: entry
      });
      if (reason === 'select-option') {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect();
      }
      clearError(keyName);
    },
    onInputChange: function onInputChange(event, newInputValue) {
      setInputValue(newInputValue);
    },
    openOnFocus: true,
    popupIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
      className: styles.icon
    }),
    renderGroup: function renderGroup(params) {
      var divider = params.group === GROUPS.PINNED ? /*#__PURE__*/React.createElement(Divider, {
        className: styles.divider
      }) : null;
      return /*#__PURE__*/React.createElement("li", {
        key: params.key
      }, /*#__PURE__*/React.createElement("ul", {
        className: styles.groupUl
      }, params.children), divider);
    },
    size: "small",
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          onFocus: function onFocus() {
            clearError(keyName);
          },
          startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start",
            className: styles.leftAdornment
          }, /*#__PURE__*/React.createElement(SearchIcon, null))
        }),
        inputProps: _objectSpread({
          'aria-label': "".concat(keyName, " input box"),
          name: keyName
        }, params.inputProps),
        label: isOutlined ? placeholder : null,
        placeholder: placeholder,
        variant: "outlined"
      }));
    },
    value: field !== null && field !== void 0 && field.code ? field : null
  }), errorMessage && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: errorMessage
  }));
}